import React from "react";
import { DialogButton, DialogConfig, createDialogConfig } from "common/component/SequentialDialog";
import { ClientReportReportTypeMap } from "../../domain";
import { createButton, getReportTypeDisplayName, getArticle } from "./utils";
import { SfReportType } from "./types";

const createContent = (inReviewReportTypes: SfReportType[]): React.ReactNode => {
  const reportTypeStrs = inReviewReportTypes.map(item => 
    getReportTypeDisplayName(item.reportType, item.caseNumber)
  );
  const reportTypeStr = reportTypeStrs.join(', ');
  const article = reportTypeStrs.length === 1 ? getArticle(reportTypeStrs[0]) : 'The';
  
  return (
    <div>
      {article} {reportTypeStr} has already been submitted. If you initially submitted the incorrect report type by mistake, select "Revised Report" to replace it.
       If you are submitting another report type for review, select "New Report".
    </div>
  );
};

const createButtons = (inReviewReportTypes: SfReportType[]): DialogButton[] => {
  const isMoreThanOneReportInReview = inReviewReportTypes.length > 1;
  const buttons = [
    createButton('New Report', { action: 'forceSubmitNew' }, 'atlantis', '120px')
  ];
  
  if (isMoreThanOneReportInReview) {
    inReviewReportTypes.forEach((item) => {
      const reportTypeName = ClientReportReportTypeMap.get(item.reportType) || '';
      const caseDisplay = item.caseNumber ? ` (${item.caseNumber})` : '';
      
      buttons.push(
        createButton(
          `Revise: ${reportTypeName}${caseDisplay}`,
          { action: 'submit', reviseReportType: item.reportType, reportItem: item },
          'green',
          '140px'
        )
      );
    });
  } else {
    const singleReviseReportType = inReviewReportTypes[0]?.reportType ?? '';
    buttons.push(
      createButton(
        'Revised',
        { action: 'submit', reviseReportType: singleReviseReportType },
        'green',
        '120px'
      )
    );
  }
  
  return buttons;
};

export const createReportInReviewDialogConfig = (
  inReviewReportTypes: SfReportType[],
  shouldShow: boolean
): DialogConfig => {
  return createDialogConfig(
    'report-in-review-confirmation',
    'Confirm!',
    createContent(inReviewReportTypes),
    createButtons(inReviewReportTypes),
    shouldShow
  );
};
